import styled from '@emotion/styled';
import React from 'react';
import { theme } from 'styles/theme/theme';

interface InspectorRowProps {
  label: string;
  children: React.ReactNode;
  highlight?: boolean;
}

const InspectorRow: React.FC<InspectorRowProps> = ({ label, children, highlight = false }) => {
  // Строка — это группа с доступным именем из подписи: так её контролы
  // адресуются по имени (within(getByRole('group', { name }))), а не обходом DOM.
  const labelId = React.useId();

  return (
    <Root role="group" aria-labelledby={labelId}>
      <Label id={labelId} highlight={highlight}>
        {label}
      </Label>
      <Control highlight={highlight}>{children}</Control>
    </Root>
  );
};

export default InspectorRow;

const Root = styled.div`
  display: grid;
  grid-template-columns: 104px 1fr;
  align-items: center;
  gap: 8px;
  font-size: 13px;
`;

const Label = styled.span<{ highlight: boolean }>`
  min-width: 0;
  overflow-wrap: break-word;
  color: ${(p) => (p.highlight ? theme.colors.error : theme.colors.Gray)};
  font-weight: ${(p) => (p.highlight ? 600 : 'normal')};
`;

const Control = styled.div<{ highlight: boolean }>`
  display: flex;
  min-width: 0;
  border-left: 2px solid ${(p) => (p.highlight ? theme.colors.error : 'transparent')};
  padding-left: ${(p) => (p.highlight ? '6px' : '0')};
`;
